import React, {Component, PropTypes} from 'react';

import Spinner from './spinner';

export default class SIMSpinner extends Component {

  componentWillMount () {
    var opts = {
      lines:  13,
      length: 0,
      width:  8,
      radius: this.props.radius,
      trail:  54 // Afterglow %
    };

    this.spinner = new Spinner(opts).spin().el.outerHTML;
  }

  componentWillUnmount () {
    this.spinner = null;
  }

  render () {
    var style = {
      height: (this.props.radius + this.props.padding) * 2 + 'px'
    };

    var className = 'spinnerwrapper';
    className += this.props.className ? ' ' + this.props.className : '';

    return (
      <div data-component="spinner" dangerouslySetInnerHTML={{__html: this.spinner}} className={className} style={style}/>
    );
  }
}

SIMSpinner.defaultProps = {
  radius:  24,
  padding: 13
};

SIMSpinner.propTypes = {
  radius:  PropTypes.number,
  padding: PropTypes.number
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/spinner/index.jsx